import { render, staticRenderFns } from "./VuehCaptcha.vue?vue&type=template&id=1e5fcb57&scoped=true"
import script from "./VuehCaptcha.vue?vue&type=script&lang=js"
export * from "./VuehCaptcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5fcb57",
  null
  
)

export default component.exports